export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";